/* eslint-disable import/no-anonymous-default-export */
import axios from './axios';

let URL = process.env.REACT_APP_PORTAL_URL;

export default {
  getTranscodeStatus(id) {
    return axios.get(`${URL}/api/v1/sessions/videos/${id}/transcode-status`);
  },
  getSessionTranscodeStatus(sessionId) {
    return axios.get(`${URL}/api/v1/sessions/videos/transcode-status`, { params: { sessionId } });
  },
  getBusyTranscodes() {
    return axios.get(`${URL}/api/v1/sessions/videos/transcode-status`);
  },
  retranscode(id) {
    return axios.post(`${URL}/api/v1/sessions/videos/transcode`, { 
      sessionId: id
    },
    {
      params: {
        sessionId: id
      }
    });
  }
};
